import { useState } from 'react';
import { useConsultantAgent } from '../../../hooks/useConsultantAgent';
import KnowledgePanel from './KnowledgePanel';
import DocumentsPanel from './DocumentsPanel';
import TeachPanel from './TeachPanel';
import TeachVoicePanel from './TeachVoicePanel';
import PendingQuestionsPanel from './PendingQuestionsPanel';
import WaitlistPanel from './WaitlistPanel';
import VoiceProviderPanel from './VoiceProviderPanel';
import '../../../styles/ConsultantTab.css';

// Model settings live beside the customer advisor under the shared AI domain:
// picks are cross-cutting (consultant + inspection + future surfaces), not
// consultant-specific.
const SUBTABS = [
  { id: 'knowledge',      label: 'پایگاه دانش' },
  { id: 'documents',      label: 'اسناد' },
  { id: 'teach',          label: 'آموزش متنی' },
  { id: 'teachVoice',     label: 'آموزش صوتی' },
  { id: 'pending',        label: 'صف سوالات' },
  { id: 'waitlist',       label: 'لیست انتظار' },
  { id: 'voice',          label: 'مشاور صوتی' },
];

export default function ConsultantTab() {
  const [sub, setSub] = useState('knowledge');
  const agent = useConsultantAgent();

  return (
    <div className="consultant-tab">
      <div className="consultant-subnav">
        {SUBTABS.map((t) => (
          <button key={t.id} className={sub === t.id ? 'active' : ''} onClick={() => setSub(t.id)}>
            {t.label}
          </button>
        ))}
      </div>
      {agent.error && (
        <div className="consultant-error" onClick={agent.clearError}>{agent.error} (برای بستن کلیک کنید)</div>
      )}
      {sub === 'knowledge'  && <KnowledgePanel agent={agent} />}
      {sub === 'documents'  && <DocumentsPanel agent={agent} />}
      {sub === 'teach'      && <TeachPanel agent={agent} />}
      {sub === 'teachVoice' && <TeachVoicePanel />}
      {sub === 'pending'    && <PendingQuestionsPanel />}
      {sub === 'waitlist'       && <WaitlistPanel agent={agent} />}
      {sub === 'voice'          && <VoiceProviderPanel />}
    </div>
  );
}
